import { Link } from "react-router-dom";
import { formatDate, formatDuration, formatNumber } from "@/lib/api";
import { Eye, Clock, Play } from "lucide-react";

export default function VideoCard({ video, size = "md" }) {
  const thumb = video.thumbnail || `https://i.ytimg.com/vi/${video.id}/hqdefault.jpg`;
  const isLg = size === "lg";
  return (
    <Link
      to={`/video/${video.id}`}
      data-testid={`video-card-${video.id}`}
      className={`group hover-lift block rounded-xl border border-white/10 bg-[#12141d] overflow-hidden`}
    >
      <div className="thumb-frame aspect-video bg-black">
        <img
          src={thumb}
          alt={video.title}
          data-testid="video-card-thumbnail"
          width="480"
          height="270"
          decoding="async"
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
          loading="lazy"
        />
        {/* Category pill */}
        {video.category && (
          <span className="absolute top-3 left-3 z-10 mono-label px-2.5 py-1 rounded-full bg-black/60 backdrop-blur-md border border-white/10">
            {video.category}
          </span>
        )}
        {/* Duration */}
        <span className="absolute bottom-3 right-3 z-10 font-mono-tech text-[11px] px-2 py-0.5 rounded bg-black/80 text-[#f4f1ea] border border-white/10">
          {formatDuration(video.duration_seconds)}
        </span>
        {/* Play button on hover */}
        <span
          data-testid="video-card-play-btn"
          className="absolute inset-0 z-10 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
        >
          <span className="w-14 h-14 rounded-full bg-[#d95d39]/90 flex items-center justify-center shadow-2xl">
            <Play className="w-6 h-6 text-white translate-x-0.5" fill="currentColor" />
          </span>
        </span>
      </div>

      <div className="p-5">
        <h3
          data-testid="video-card-title"
          className={`${isLg ? "text-xl font-serif-editorial" : "text-base font-medium"} leading-snug text-[#f4f1ea] line-clamp-2 group-hover:text-[#d95d39] transition-colors`}
        >
          {video.title}
        </h3>
        <div className="mt-4 flex items-center gap-4 text-[11px] font-mono-tech uppercase tracking-widest text-white/50">
          <span className="inline-flex items-center gap-1.5">
            <Eye className="w-3.5 h-3.5" /> {formatNumber(video.view_count)}
          </span>
          <span className="inline-flex items-center gap-1.5">
            <Clock className="w-3.5 h-3.5" /> {formatDate(video.published_at)}
          </span>
        </div>
      </div>
    </Link>
  );
}
